<template>
<div>

  <q-dialog v-model="formDialog"  persistent position="right">
    <q-card style="min-width: 800px;max-height: 100vh">
      <q-card-section>
        <div class="text-h6">Stock Transfer
          <q-btn class="float-right" @click="closeDialog" flat round icon="close" size="small"></q-btn>
        </div>
      </q-card-section>
      <q-separator/>

      <q-card-section style="max-height:80vh;overflow-y: scroll">
        <q-form ref="form">
          <div class="row q-col-gutter-sm">
            <div class="q-pa-md col-12">
              <div>
                Batches : <template v-for="b in batches"><b>{{b.batch}}</b></template>
                <div class="my-4">
                  <q-select :options="organizationArr"
                            :rules="[val=>val && typeof(val) === 'object' || 'Please select Organization']"
                            @filter="searchOrganization" class="searchBox w-100 p-2 mb-3" clearable
                            label="Select Organizations *" outlined use-input v-model="selectedOrgObj">
                    <template v-slot:no-option>
                      <q-item>
                        <q-item-section class="text-grey">
                          No results
                        </q-item-section>
                      </q-item>
                    </template>
                    <template v-slot:option="scope">
                      <q-item v-bind="scope.itemProps" v-on="scope.itemEvents">
                        <q-item-section>
                          <q-item-label v-html="scope.opt.name"></q-item-label>
                          <q-item-label caption>{{ scope.opt.mobile }}</q-item-label>
                        </q-item-section>
                        <q-item-section>
                          <q-item-label>{{ scope.opt.partnerCode }}</q-item-label>
                        </q-item-section>
                      </q-item>
                    </template>
                    <template v-slot:selected-item="scope">
                      <q-item-label v-html="scope.opt.name"></q-item-label>
                    </template>
                  </q-select>
                </div>
                <div class="my-4">
                  <q-input :rules="[val=>val && val.length>0 || 'Please select order date']"
                           class="searchBox p-2 my-3" filled label="Order Date *"
                           mask="##/##/####"
                           v-model="orderDateComp">
                    <template v-slot:append>
                      <q-icon class="cursor-pointer " name="event">
                        <q-popup-proxy ref="orderDate" transition-hide="scale"
                                       transition-show="scale">
                          <q-date :options="optionsFn"
                                  @input="() => $refs.orderDate.hide()" v-model="form.date"/>
                        </q-popup-proxy>
                      </q-icon>
                    </template>
                  </q-input>
                </div>
                <div class="my-4">
                  <q-input :rules="[val=>val && val.length>0 || 'Please enter invoice number']"
                           class="searchBox p-2 my-3" label="Invoice No. *"
                           v-model="form.invoiceNumber"></q-input>
                </div>
                <div class="my-4">
                  <q-input :rules="[val=>val && val.length>0 || 'Please select invoice date']"
                           class="searchBox p-2 my-3" filled label="Invoice Date *"
                           mask="##/##/####"
                           v-model="invoiceDateComp">
                    <template v-slot:append>
                      <q-icon class="cursor-pointer " name="event">
                        <q-popup-proxy ref="invoiceDate" transition-hide="scale"
                                       transition-show="scale">
                          <q-date @input="() => $refs.invoiceDate.hide()"
                                  v-model="form.invoiceDate"/>
                        </q-popup-proxy>
                      </q-icon>
                    </template>
                  </q-input>
                </div>
                <div class="my-4">
                  <q-input class="searchBox" label="Note/Remark" style="height: auto;" type="textarea"
                           v-model="form.invoiceNote"></q-input>
                </div>

              </div>
            </div>

          </div>
        </q-form>
      </q-card-section>
      <q-separator/>
      <q-card-actions>
        <q-btn label="TRANSFER" @click="handleSubmit" class="pd-btn ml-2 mr-2" :loading="formLoading"/>
        <q-btn label="CANCEL" @click="closeDialog" color="grey" />
      </q-card-actions>

    </q-card>
  </q-dialog>

</div>
</template>

<script>
import moment from "moment/moment";
import Constants from "@/Constants/Constant";
import {
  SEARCH_ORGANIZATION_IN_STOCK_TRANSFER_WITH_DETAILS
} from "@/graphql/queries/organization";
import {INSERT_ORDER_AND_MULTIPLE_ORDER_ITEMS} from "@/graphql/mutations/products";
import retailSalesEntry from "@/mixins/retailSalesEntry";

let form = {invoiceNumber:'', invoiceNote:'', invoiceDate:moment(), date: moment()};
export default {
  name: "TransferBatch",
  props: ['formDialog'],
  mixins: [retailSalesEntry],
  apollo: {
    Organizations: {
      query: SEARCH_ORGANIZATION_IN_STOCK_TRANSFER_WITH_DETAILS,
      fetchPolicy: 'network-only',
      variables () {
        return {
          orgFilter: this.orgFilter,
          prefferedVP: this.user.orgId,
          partnerType: this.user.organization.partnerType === Constants.VAD ?
              [Constants.VAD, Constants.RD, Constants.ND] : [Constants.RD, Constants.ND],
        }},
      result ({ data, loading }) { if (!loading) this.organizationArr = data.Organizations }
    },
  },
  data(){
    return {
      user: JSON.parse(localStorage.user),
      moment: moment,
      Constants: Constants,
      form: {...form},
      formLoading: false,
      organizationArr: [],
      orgFilter: '%%',
      selectedOrgObj: '',
      invoiceDateComp: moment().format('DD/MM/YYYY'),
      orderDateComp: moment().format('DD/MM/YYYY'),
      batches: []
    }
  },
  watch:{
    'form.invoiceDate' (val) {
      this.invoiceDateComp = moment(val).format('DD/MM/YYYY')
    },
    'form.date' (val) {
      this.orderDateComp = moment(val).format('DD/MM/YYYY')
    },
  },
  methods:{
    setBatches(batches){
      this.batches = batches;
    },
    optionsFn (date) {
      return date >= moment().subtract(7, 'days').format('YYYY/MM/DD') && date <= moment().format('YYYY/MM/DD')
    },
    searchOrganization (val, update, abort) {
      if(val.length < 1) return abort();
      update(() => { this.orgFilter = '%' + val + '%' })
    },
    handleSubmit(){
      this.$refs['form'].validate().then(success => {
        if(success) this.saveOrder();
        else this.$q.notify('Please review the form errors highlighted in red')
      })
    },
    async saveOrder(){
      this.formLoading = true;
      let toOrgId = this.selectedOrgObj.id;

      let orderItemArr = this.batches.map(b => ({
          id: Constants.generateUUID(),
          qty: this.batches.length, from: this.user.orgId, to: toOrgId,
          notes: '', sellType: '1', batchId: b.id,
          productInventoryId: toOrgId, productId: b.Product.id,
          status: 'Sold', meta: null
      }))

      let orderRequest = {
        ...this.form, id: Constants.generateUUID(),
        from: this.user.orgId, to: toOrgId, lineItemCounts: this.batches.length,
        status: 'Sold', placedBy: this.user.id, notes: '', orderType: 1,
        OrderItems: { data: orderItemArr.length ? orderItemArr : null },
      }
      let response = await this.$apollo.mutate({
        mutation: INSERT_ORDER_AND_MULTIPLE_ORDER_ITEMS,
        variables: { orderObj: orderRequest }
      })
      if (response.data) {
        this.$q.notify('Batch Transfer Successfully')
        // Check transfer to VAP. RP... If yes, add RetailSales entry for each subBatches
        if([Constants.VAP, Constants.RP].includes(this.selectedOrgObj.partnerType))
          await this.addRetailSales(this.selectedOrgObj, this.batches)
        this.formLoading = false;
        this.closeDialog();
      }
    },
    async addRetailSales(org, batches){
      let from = {orgId:org.id, userId:org.Users[0].id}
      for(const b of batches){
        for(const sb of b.subBatches){
          await this.addEntry(sb.serial, from);
        }
      }
    },
    closeDialog(){
      this.form = {...form}
      this.batches = []
      this.selectedOrgObj = ''
      this.$emit('update:formDialog', false)
    }
  }
}
</script>

<style scoped>

</style>